import { formatSize } from '../orders/size.utils';
import type { CustomerSizeTotals } from './customer';

export interface CustomerSizeRow extends CustomerSizeTotals {
  readonly sizeKey: string;
  /** e.g. "10 × 15 cm", null for "unknown" or anything else that isn't a size key. */
  readonly label: string | null;
}

/** "10x15" → "10 × 15 cm", null for "unknown" or anything else that isn't a size key. */
export const formatSizeKey = (sizeKey: string): string | null => {
  const [width, height] = sizeKey.split('x').map(Number);
  return Number.isFinite(width) && Number.isFinite(height) ? formatSize({ width, height }) : null;
};

/** Printed totals per size, the most ordered size first. */
export const sizesByOrders = (bySize: Readonly<Record<string, CustomerSizeTotals>>): CustomerSizeRow[] =>
  Object.entries(bySize)
    .map(([sizeKey, totals]) => ({ sizeKey, label: formatSizeKey(sizeKey), ...totals }))
    .sort((a, b) => b.orders - a.orders || b.photos - a.photos);
